/**
 * @generated SignedSource<<a67bf5aa1ee2fa0cd0cb3e5f4e65b03e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type apiKeysQuery$variables = {
  id: string;
};
export type apiKeysQuery$data = {
  readonly apiKeyBySalesChannelID: {
    readonly clientID: number;
    readonly secretKey: string | null;
  };
};
export type apiKeysQuery = {
  response: apiKeysQuery$data;
  variables: apiKeysQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secretKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiKeysQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApiKey",
        "kind": "LinkedField",
        "name": "apiKeyBySalesChannelID",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiKeysQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApiKey",
        "kind": "LinkedField",
        "name": "apiKeyBySalesChannelID",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6fc00122351cb05366a66d7ede4e9ae9",
    "id": null,
    "metadata": {},
    "name": "apiKeysQuery",
    "operationKind": "query",
    "text": "query apiKeysQuery(\n  $id: ID!\n) {\n  apiKeyBySalesChannelID(id: $id) {\n    clientID\n    secretKey\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f954d658687c2818be61a9b06101ee8";

export default node;
